import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    card: {
        marginTop: `${theme.spacing(6)} !important`,
    },
    cardContentComments: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        padding: `${theme.spacing(4)} !important`,
        maxHeight: "750px",
        overflowY: "auto",
        overflowX: "hidden",
    },
    showMoreWrapper: {
        display: "flex",
        justifyContent: "center",
        marginBottom: theme.spacing(2),
    },
    showMoreButton: {
        padding: "0px !important",
        display: "flex !important",
        alignItems: "center !important",
        border: "none !important",
        gap: "4px !important",
        "&.MuiButton-root": {
            fontFamily: "Source Sans 3 !important",
            fontSize: "12px !important",
            fontWeight: "700 !important",
        },
    },
}));
